// Controlled vocabularies for the Lead Intake module (PROMPT 6)
export const LEAD_SOURCES = [
  { value: "website_form", label: "Website Form" },
  { value: "reverse_landing_page", label: "Reverse Landing Page" },
  { value: "phone_call", label: "Phone Call" },
  { value: "email", label: "Email" },
  { value: "live_chat", label: "Live Chat" },
  { value: "newsletter", label: "Newsletter" },
  { value: "trilogy_event", label: "Trilogy Event" },
  { value: "partner_referral", label: "Partner Referral" },
  { value: "senior_facility_event", label: "Senior Facility Event" },
  { value: "google_search", label: "Google Search" },
  { value: "facebook_social", label: "Facebook / Social Media" },
  { value: "manual_entry", label: "Manual Entry" },
  { value: "qr_code", label: "QR Code" },
  { value: "other", label: "Other" },
];

export const URGENCY_LEVELS = [
  { value: "emergency", label: "Emergency / needs help now", tone: "red" },
  { value: "within_7_days", label: "Within 7 days", tone: "red" },
  { value: "within_30_days", label: "Within 30 days", tone: "amber" },
  { value: "days_30_60", label: "30\u201360 days", tone: "sky" },
  { value: "days_60_90", label: "60\u201390 days", tone: "sky" },
  { value: "just_researching", label: "Just researching", tone: "gray" },
  { value: "not_sure", label: "Not sure", tone: "gray" },
];

export const SERVICE_INTERESTS = [
  { value: "sell_home", label: "I need to sell Mom\u2019s home", short: "Sell the Home" },
  { value: "senior_placement", label: "I need to find senior living or care placement", short: "Senior Placement" },
  { value: "home_safety", label: "I want to keep Mom safe at home", short: "Keep Mom Safe" },
  { value: "move_into_my_home", label: "I want to move Mom into my home", short: "Move In With Family" },
  { value: "downsizing", label: "I need help downsizing or handling belongings", short: "Downsizing" },
  { value: "needs_guidance", label: "I am overwhelmed and not sure where to start", short: "Needs Guidance" },
];

export const LEAD_STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "consultation_requested", label: "Consultation Requested" },
  { value: "consultation_booked", label: "Consultation Booked" },
  { value: "consultation_completed", label: "Consultation Completed" },
  { value: "converted", label: "Converted to Family Case" },
  { value: "not_ready", label: "Not Ready" },
  { value: "follow_up_later", label: "Follow-Up Later" },
  { value: "closed_lost", label: "Closed / Lost" },
];

export const CONTACT_METHODS = [
  { value: "phone", label: "Phone call" },
  { value: "email", label: "Email" },
  { value: "sms", label: "Text / SMS" },
  { value: "any", label: "Any method" },
];

export const RELATIONSHIPS = [
  { value: "child", label: "Son / Daughter" },
  { value: "spouse", label: "Spouse / Partner" },
  { value: "sibling", label: "Sibling" },
  { value: "grandchild", label: "Grandchild" },
  { value: "relative", label: "Other relative" },
  { value: "friend", label: "Friend / Neighbor" },
  { value: "professional", label: "Professional / Advisor" },
  { value: "other", label: "Other" },
];

export const labelOf = (arr, val) => arr.find((o) => o.value === val)?.label || (val || "");
export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
